import { useState } from 'react';

const useFormikSubmit = () => {
  const [formikSubmit, setFormikSubmit] = useState(() => {});

  return [formikSubmit, setFormikSubmit];
};

export default useFormikSubmit;
